import type { AiContextSnapshot } from "@/lib/auth";
import { formatSlaBreachLabel, formatSlaLabel } from "./slaState";

function dedupeChip(chips: string[], label: string | undefined) {
  if (!label) {
    return;
  }
  if (!chips.includes(label)) {
    chips.push(label);
  }
}

export function buildSnapshotChips(snapshot: AiContextSnapshot): string[] {
  const chips: string[] = [];
  if (snapshot.priority === "high" || snapshot.priority === "critical") {
    dedupeChip(chips, "High urgency");
  }

  const slaBreach = formatSlaBreachLabel(snapshot.slaState.minutesRemaining);
  if (snapshot.slaState.status === "at_risk") {
    dedupeChip(chips, slaBreach ?? "SLA at risk");
  } else if (snapshot.slaState.status === "breached") {
    dedupeChip(chips, "SLA breached");
  }

  if (snapshot.fallbackUsed) {
    dedupeChip(chips, "Fallback inference");
  }

  const combined = [...snapshot.insights, ...snapshot.guardrailWarnings]
    .join(" ")
    .toLowerCase();
  if (combined.includes("escalat")) {
    dedupeChip(chips, "Customer escalated");
  }
  if (combined.includes("confidence")) {
    dedupeChip(chips, "Confidence guardrail");
  }

  return chips;
}

export { formatSlaLabel };

export function formatContextSnapshotClipboard(snapshot: AiContextSnapshot): string {
  const lines: string[] = [];
  lines.push(
    `AI Context Snapshot · ${new Date(snapshot.generatedAt).toLocaleString()}`
  );
  lines.push(`Priority: ${snapshot.priority}`);
  lines.push(`SLA: ${formatSlaLabel(snapshot.slaState)}`);
  lines.push(`Confidence: ${snapshot.confidence.toFixed(2)}`);
  lines.push(`Impact: ${snapshot.impact}`);
  if (snapshot.intent) {
    lines.push(`Intent: ${snapshot.intent}`);
  }
  if (snapshot.customer) {
    lines.push(`Customer: ${snapshot.customer}`);
  }
  if (snapshot.triageRule) {
    lines.push(`Triage rule: ${snapshot.triageRule}`);
  }
  lines.push("\nInsights:");
  snapshot.insights.forEach((insight, index) => {
    lines.push(`${index + 1}. ${insight}`);
  });
  if (snapshot.guardrailWarnings.length) {
    lines.push("\nGuardrail notes:");
    snapshot.guardrailWarnings.forEach((warning) => {
      lines.push(`- ${warning}`);
    });
  }
  lines.push("\nDiagnostics:");
  lines.push(`Request ID: ${snapshot.requestId}`);
  return lines.join("\n");
}
